var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"font-15"},[_c('span',{staticClass:"font-weight-medium pr-1"},[(_vm.linha.idcategoria)?[_vm._v("Categoria:")]:_vm._e()],2),_c('span',[(_vm.linha.idcategoria)?[_vm._v(_vm._s(`${_vm.linha.idcategoria} - ${_vm.linha.descricao_categoria}`))]:[_vm._v("Todas as categorias")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }